export default {
  cursor: 'pointer',
};
